"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStoryblokConfig = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@storyblok/react");
var TBTermDefinitions_1 = require("../components/storyblokComponents/TBTermDefinitions");
var TBYoutubeEmbed_1 = require("../components/storyblokComponents/TBYoutubeEmbed");
var TBCommunityCTA_1 = require("../components/storyblokComponents/TBCommunityCTA");
var TBAccordion_1 = require("../components/storyblokComponents/TBAccordion");
var TBHero_1 = require("../components/storyblokComponents/TBHero");
var TBContainer_1 = require("../components/storyblokComponents/TBContainer");
var TBTestimonials_1 = require("../components/storyblokComponents/TBTestimonials");
var TBCarousel_1 = require("../components/storyblokComponents/TBCarousel");
var TBFeature_1 = __importDefault(require("../components/storyblokComponents/TBFeature"));
var helpers_1 = require("../helpers");
var TBCalculator_1 = require("../components/storyblokComponents/TBCalculator");
__exportStar(require("./TopiaStoryblokComponent"), exports);
exports.defaultStoryblokConfig = {
    apiOptions: {
        region: "us", // Pass this key/value if your space was created under US region
    },
    use: [react_1.apiPlugin],
    components: {
        //   countdown_timer: CountdownTimer,
        image: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("img", __assign({ className: "".concat(blok.className) }, (0, react_1.storyblokEditable)(blok), { src: blok.image.filename, width: blok.width || undefined, height: blok.height || undefined, alt: blok.image.alt })));
        },
        section: function (_a) {
            var blok = _a.blok;
            var clipPath = "";
            if (blok.clip_path) {
                if (blok.clip_path === "bottom-edge-1") {
                    clipPath =
                        "polygon(0 0, 100% 0, 100% 30%, 100% 96%, 38% 98%, 0 93%, 0 73%, 0 16%)";
                }
            }
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, helpers_1.topiaBlockClassnames)(blok), style: {
                    clipPath: clipPath,
                } }, (0, react_1.storyblokEditable)(blok), { children: blok.body.map(function (nestedBlok) { return ((0, jsx_runtime_1.jsx)(react_1.StoryblokComponent, { blok: nestedBlok }, nestedBlok._uid)); }) })));
        },
        container: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBContainer_1.TBContainer, { blok: blok });
        },
        grid: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "md:grid md:grid-cols-".concat(blok.columns.length, " gap-4 ").concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { children: blok.columns.map(function (nestedBlok) { return ((0, jsx_runtime_1.jsx)(react_1.StoryblokComponent, { blok: nestedBlok }, nestedBlok._uid)); }) })));
        },
        flexbox: function (_a) {
            var blok = _a.blok;
            var prefix = blok.min_flex_level ? "".concat(blok.min_flex_level, ":") : "lg:";
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-".concat(blok.mobile_flex_direction || blok.flex_direction, " ").concat(prefix, "flex-").concat(blok.flex_direction || "row", " ").concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { children: blok.children.map(function (nestedBlok) { return ((0, jsx_runtime_1.jsx)(react_1.StoryblokComponent, { blok: nestedBlok }, nestedBlok._uid)); }) })));
        },
        content: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat((0, helpers_1.topiaBlockClassnames)(blok), " topia-sb-rich-text") }, (0, react_1.storyblokEditable)(blok), { dangerouslySetInnerHTML: {
                    __html: (0, helpers_1.topiaRichText)(blok.content),
                } })));
        },
        h1: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("h1", __assign({ className: "text-3xl ".concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { dangerouslySetInnerHTML: { __html: (0, helpers_1.topiaRichText)(blok.text) } })));
        },
        h2: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("h2", __assign({ className: "text-2xl ".concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { dangerouslySetInnerHTML: { __html: (0, helpers_1.topiaRichText)(blok.text) } })));
        },
        h3: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-xl ".concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { dangerouslySetInnerHTML: { __html: (0, helpers_1.topiaRichText)(blok.text) } })));
        },
        h4: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("h4", __assign({ className: "text-lg ".concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { dangerouslySetInnerHTML: { __html: (0, helpers_1.topiaRichText)(blok.text) } })));
        },
        h5: function (_a) {
            var blok = _a.blok;
            return ((0, jsx_runtime_1.jsx)("h5", __assign({ className: "text-lg ".concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { dangerouslySetInnerHTML: { __html: (0, helpers_1.topiaRichText)(blok.text) } })));
        },
        feature: TBFeature_1.default,
        youtube_embed: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBYoutubeEmbed_1.TBYoutubeEmbed, { blok: blok });
        },
        // icon_picker: IconPicker,
        // traditional_vs_fipreneur: TraditionalVsFIPReneur,
        term_definition: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBTermDefinitions_1.TBTermDefinitions, { blok: blok });
        },
        // as_seen_on: ({ blok }) => <TBAsSeenOn blok={blok} />,
        // app_store_buttons: ({ blok }) => (
        //   <AppStoreButtons
        //     className="flex flex-row gap-4"
        //     webSignUpOnDesktop={blok.web_sign_up_on_desktop}
        //   />
        // ),
        calculator: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBCalculator_1.TBCalculator, { blok: blok });
        },
        community_cta: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBCommunityCTA_1.TBCommunityCTA, { blok: blok });
        },
        hero: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBHero_1.TBHero, { blok: blok });
        },
        accordion: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBAccordion_1.TBAccordion, { blok: blok });
        },
        carousel: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBCarousel_1.TBCarousel, { blok: blok });
        },
        testimonial: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)(TBTestimonials_1.TBTestimonials, { blok: blok });
        },
        fire_calculator: function (_a) {
            var blok = _a.blok;
            return (0, jsx_runtime_1.jsx)("div", {});
        },
    },
};
